import { RootState } from "@/store/types";
import { TranslateFunction } from "@fkui/logic";
import { ForstegFormatService } from "./ForstegFormatService";
import { KontaktuppgifterFormatService } from "./KontaktuppgifterFormatService";
import { MisstankeFormatService } from "./MisstankeFormatService";

export class MailFormatService {
    private forstegFormatService: ForstegFormatService;
    private kontaktuppgifterFormatService: KontaktuppgifterFormatService;
    private misstankeFormatService: MisstankeFormatService;
    public $t!: TranslateFunction;

    public constructor(translateFunction: TranslateFunction) {
        this.forstegFormatService = new ForstegFormatService(translateFunction);
        this.kontaktuppgifterFormatService = new KontaktuppgifterFormatService(
            translateFunction,
        );
        this.misstankeFormatService = new MisstankeFormatService(
            translateFunction,
        );
        this.$t = translateFunction;
    }

    public getFormattedMail(state: RootState): string {
        return this.getMailIntro().concat(
            this.forstegFormatService
                .getContent(state)
                .concat(
                    "\n\n",
                    this.kontaktuppgifterFormatService.getContent(state),
                    "\n\n",
                    this.misstankeFormatService.getContent(state),
                    "\n\n",
                )
                // Replace non line breaking hyphen with a regular hyphen as it will not pass whitelist in backend
                .replace(/‑/g, "-"),
        );
    }

    public getMailIntro(): string {
        const header =
            "impulskontrollutredning.anmalan.generell.epost.meddelande.rubrik";
        const content =
            "impulskontrollutredning.anmalan.generell.epost.meddelande.beskrivning";
        return `@s@${this.$t(header)}@!s@ \n ${this.$t(content)} \n\n`;
    }
}
